import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material";

const WideDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    maxWidth: "1000px",
    width: "80%",
  },
}));

export const AlertDialog = ({
  open,
  title,
  cancelTitle,
  confirmTitle,
  handleClose,
  handleConfirm,
  text,
}: {
  open: boolean;
  title: string;
  cancelTitle: string;
  confirmTitle: string;
  handleClose: () => void;
  handleConfirm: () => void;
  text: string;
}) => {
  return (
    <React.Fragment>
      <WideDialog open={open} keepMounted onClose={handleClose} aria-describedby="alert-dialog-slide-description">
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>{text}</DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{cancelTitle}</Button>
          <Button onClick={handleConfirm}>{confirmTitle}</Button>
        </DialogActions>
      </WideDialog>
    </React.Fragment>
  );
};
